import React from "react";
import { Link } from "react-router-dom";
import closeImage from "../assets/svgs/close_white_icon.svg";
import { DIRECTORY } from "../constants/routesPaths";
import { analytics } from "../firebase.config";

function SlidingAdMenu(props) {

  const adVetClick = (vetname) => {
    analytics.logEvent(`Action_SlidingAdVet`, {
      vetName: vetname
    });
  };

  let filteredVetData = props.vetsData.filter((item) => {
    return item.recommended;
  });

  return (
    <div className={`sliding-menu ${props.slidingMenuState ? "active" : ""}`}>
      <div className={"sliding-menu_close"}>
        <img
          onClick={() => {
            props.onClose()
          }}
          src={closeImage}
          alt={"Close icon"}
        />
      </div>
      <Link className={'sliding-menu--seeAll'} to={DIRECTORY}>
        <div className={'sliding-menu--seeAll-container'}>
          Ver todo directorio
        </div>
      </Link>
      {filteredVetData.map((vet) => {
        const imag = vet.image? require('../assets/'+ vet.image): "";
        return (
          <a key={vet.key} onClick={() => {
            adVetClick(vet.name);
          }} href={vet.linkTo} target={"__blank"}>
            <div className={"vet-menu-item"}>
              <div className={"vet-menu-item--container"}>
                <img
                  className={"vet-menu-item--image"}
                  src={imag.default}
                  alt={vet.name}
                />
                <div className={"vet-menu-item--social"}>
                  {typeof vet.social.facebook !== "undefined" &&
                    vet.social.facebook !== "" && (
                      <a
                        className={"vet-menu-item--social-item"}
                        target={"__blank"}
                        href={vet.social.facebook}
                      >
                        <img src={props.facebookIcon} alt={"Facebook icon"} />
                      </a>
                    )}
                  {typeof vet.social.instagram !== "undefined" &&
                    vet.social.instagram !== "" && (
                      <a
                        className={"vet-menu-item--social-item"}
                        target={"__blank"}
                        href={vet.social.instagram}
                      >
                        <img src={props.instagramIcon} alt={"Instagram icon"} />
                      </a>
                    )}
                  {typeof vet.social.website !== "undefined" &&
                    vet.social.website !== "" && (
                      <a
                        className={"vet-menu-item--social-item"}
                        target={"__blank"}
                        href={vet.social.website}
                      >
                        <img src={props.websiteIcon} alt={"Website icon"} />
                      </a>
                    )}
                  {typeof vet.social.phone !== "undefined" &&
                    vet.social.phone !== "" && (
                      <a
                        className={"vet-menu-item--social-item"}
                        href={vet.social.phone}
                      >
                        <img src={props.phoneIcon} alt={"Phone icon"} />
                      </a>
                    )}
                </div>
                <div className={"vet-menu-item--information"}>
                  <div className={"vet-menu-item--title"}>{vet.name}</div>
                  <div className={"vet-menu-item--desc"}>{vet.description}</div>
                  {typeof vet.location !== "undefined" && vet.location !== "" && 
                  <div className={"vet-menu-item--location"}>
                    <p className={"vet-menu-item--subtitle"}>Dirección:</p>
                    <p>{vet.location}</p>
                  </div>}
                </div>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
}

export default SlidingAdMenu;
